import { Box, Breakpoint, Container, Stack } from "@mui/material";
import { PropsWithChildren } from "react";

type Props = {
    maxWidth?: Breakpoint;
};

export default function GaiaPageLayoutColumn({ children, maxWidth = "md" }: PropsWithChildren<Props>) {
    return (
        <Box py={1}>
            <Container maxWidth={maxWidth}>
                <Stack gap={2} sx={{ overflowX: "clip" }}>
                    {children}
                </Stack>
            </Container>
        </Box>
    );
}
